module.exports = __webpack_public_path__ + "static/img/banner12.a602082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner12.png
// module id = 4lG1
// module chunks = 1